export const MicArt = ({ className = "" }) => (
  <svg viewBox="0 0 120 150" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="micSilver" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stopColor="#8a93a3" />
        <stop offset="0.35" stopColor="#e8ecf2" />
        <stop offset="0.6" stopColor="#c0c7d1" />
        <stop offset="1" stopColor="#6f7889" />
      </linearGradient>
      <linearGradient id="micGrille" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#f4f6fa" />
        <stop offset="0.5" stopColor="#aeb6c4" />
        <stop offset="1" stopColor="#5d6575" />
      </linearGradient>
      <linearGradient id="micArm" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#d7dde6" />
        <stop offset="1" stopColor="#7a8494" />
      </linearGradient>
    </defs>
    {/* brazo articulado */}
    <g stroke="url(#micArm)" strokeWidth="5" strokeLinecap="round" fill="none">
      <path d="M8 10 L44 26" />
      <path d="M44 26 L60 14" />
    </g>
    <circle cx="8" cy="10" r="4.5" fill="#c0c7d1" />
    <circle cx="44" cy="26" r="5" fill="#0057FF" />
    <circle cx="60" cy="14" r="4" fill="#c0c7d1" />
    {/* soporte / araña */}
    <path d="M60 14 Q78 22 66 40" stroke="url(#micArm)" strokeWidth="4" fill="none" strokeLinecap="round" />
    <ellipse cx="62" cy="78" rx="34" ry="46" fill="none" stroke="#9aa3b2" strokeWidth="2.5" opacity="0.8" />
    {/* cuerpo */}
    <rect x="46" y="86" width="32" height="42" rx="9" fill="url(#micSilver)" stroke="#525a68" strokeWidth="1" />
    <rect x="46" y="92" width="32" height="5" rx="2.5" fill="#0057FF" opacity="0.9" />
    <circle cx="62" cy="114" r="4" fill="#0057FF" />
    {/* rejilla */}
    <ellipse cx="62" cy="62" rx="22" ry="26" fill="url(#micGrille)" stroke="#525a68" strokeWidth="1" />
    <g stroke="#3d4452" strokeWidth="0.9" opacity="0.55">
      <path d="M42 52 H82 M41 60 H83 M42 68 H82 M45 76 H79" />
      <path d="M52 38 V85 M62 36 V88 M72 38 V85" />
    </g>
    <ellipse cx="54" cy="50" rx="6" ry="10" fill="#ffffff" opacity="0.35" />
    {/* anillo azul */}
    <rect x="44" y="82" width="36" height="5" rx="2.5" fill="#0057FF" />
    {/* sombra */}
    <ellipse cx="62" cy="142" rx="24" ry="5" fill="#000" opacity="0.25" />
  </svg>
);

export const CameraArt = ({ className = "" }) => (
  <svg viewBox="0 0 140 100" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="camBody" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#dfe4ec" />
        <stop offset="0.45" stopColor="#aab2c0" />
        <stop offset="1" stopColor="#59616f" />
      </linearGradient>
      <radialGradient id="camLens" cx="0.4" cy="0.35" r="0.8">
        <stop offset="0" stopColor="#8AB0FF" />
        <stop offset="0.4" stopColor="#0d2d6b" />
        <stop offset="1" stopColor="#03102e" />
      </radialGradient>
    </defs>
    {/* visor */}
    <rect x="52" y="8" width="34" height="14" rx="4" fill="url(#camBody)" stroke="#474e5b" strokeWidth="1" />
    {/* cuerpo */}
    <rect x="14" y="20" width="112" height="66" rx="10" fill="url(#camBody)" stroke="#474e5b" strokeWidth="1.2" />
    {/* grip */}
    <rect x="14" y="24" width="22" height="58" rx="8" fill="#6c7585" />
    <rect x="17" y="30" width="16" height="44" rx="6" fill="#59616f" />
    {/* lente */}
    <circle cx="86" cy="53" r="27" fill="#3c4450" stroke="#2a303a" strokeWidth="2" />
    <circle cx="86" cy="53" r="22" fill="url(#camLens)" />
    <circle cx="86" cy="53" r="22" fill="none" stroke="#0057FF" strokeWidth="2" opacity="0.9" />
    <circle cx="78" cy="45" r="6" fill="#ffffff" opacity="0.5" />
    <circle cx="94" cy="62" r="3" fill="#8AB0FF" opacity="0.6" />
    {/* detalles */}
    <rect x="42" y="26" width="26" height="6" rx="3" fill="#0057FF" opacity="0.85" />
    <circle cx="121" cy="30" r="4" fill="#0057FF" />
    <rect x="44" y="76" width="18" height="4" rx="2" fill="#474e5b" />
    {/* sombra */}
    <ellipse cx="72" cy="94" rx="40" ry="5" fill="#000" opacity="0.25" />
  </svg>
);

const HEIGHTS = Array.from({ length: 72 }, (_, i) =>
  Math.round(10 + 30 * Math.abs(Math.sin(i * 0.48)) + 14 * Math.abs(Math.sin(i * 0.17 + 1.3)))
);

export const Waveform = () => (
  <div className="wave-wrap" aria-hidden="true" data-testid="hero-waveform">
    {HEIGHTS.map((h, i) => (
      <span
        key={i}
        className="wave-bar"
        style={{ height: `${h}px`, animationDelay: `${(i % 9) * 0.22}s`, animationDuration: `${2 + (i % 5) * 0.35}s` }}
      />
    ))}
  </div>
);
